import { jsx } from 'react/jsx-runtime';
import { styled, alpha } from '@mui/material';
import MuiBox from '@mui/material/Box';
import MuiTypography from '@mui/material/Typography';

const Root = styled(MuiBox) `
  display: flex;
  flex: 1;
  border-top: 1px solid ${({ theme }) => theme.palette.N50.main};
  justify-content: space-evenly;
  max-width: 294px;
  max-height: 35px;
`;
const VARIANTS_BY_INDEX = ['secondary', 'primary'];
const getStyles = ({ theme, isSingle }) => {
    if (isSingle) {
        return `
      border-radius: 0 0 12px 12px;
      max-width: 296px; 
    `;
    }
    else {
        return `
      :first-of-type {
      border-right: 1px solid ${theme.palette.N50.main};
      border-radius: 0 0 0 12px;
      }
      :last-of-type {
      border-radius: 0 0 12px 0;
      }
    `;
    }
};
const ToastButton = styled(MuiBox, {
    shouldForwardProp: prop => !['isSingle', 'variant'].includes(prop),
}) `
  padding: ${({ theme }) => theme.spacing(2, 4, 2.75, 4)};
  flex: 1;
  display: flex;
  justify-content: center;
  max-width: 147px;
  align-items: center;
  cursor: pointer;
  height: 30px;
  color: ${({ theme, variant }) => theme.palette[variant === 'secondary' ? 'N20' : 'primary'].main};
  :hover {
    color: ${({ theme }) => theme.palette.primary.light};
    background-color: ${({ theme }) => alpha(theme.palette.primary.main, 0.2)};
  }
  > * {
    height: 16px;
  }
  ${({ theme, isSingle }) => getStyles({ theme, isSingle })};
`;
const ToastActions = ({ actionButtons }) => {
    const isSingle = (actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.length) === 1;
    if (!(actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.length)) {
        return null;
    }
    return (jsx(Root, { children: actionButtons.map(({ onClick, title, variant }, index) => (jsx(ToastButton, Object.assign({ onClick: () => onClick(), isSingle: isSingle, variant: isSingle ? variant : VARIANTS_BY_INDEX[index] }, { children: jsx(MuiTypography, Object.assign({ variant: "button", noWrap: true }, { children: title })) }), index))) }));
};

export { ToastActions as default };
//# sourceMappingURL=ToastActions.js.map
